import { CCol, CImg, CRow } from '@coreui/react'
import { Icon } from '@iconify/react'
import React from 'react'
import coopsyslogo from "../../../../img/CoopSysLogo.png";

export const RegisterStepLeft = ({ DataForm }) => {
    return (
        <CCol xs="4" className="d-none d-md-block" >
            <CRow>
                <CCol>
                    <CImg
                        id="logo"
                        style={{ width: 150 }}
                        src={coopsyslogo}
                    />
                </CCol>
            </CRow>
            <CRow >
                <CCol className="d-flex justify-content-center align-items-center" style={{ width: '100%', height: 400 }}>
                    {parseInt(DataForm.estado) === 1 ? <Icon icon="ion:business-sharp" width={200} color="#40b549" />
                        :
                        <Icon icon="vaadin:group" width={200} color="#40b549" />
                    }
                </CCol>
            </CRow>

        </CCol>
    )
}
